import React, {Component} from 'react';
import {withScriptjs, withGoogleMap, GoogleMap} from "react-google-maps";
import {connect} from "react-redux";
import {byPropKey} from "../../utils";
import {dbase} from "../../../firebase/index";
import UnitMarker from "./UnitMarker";
import MarkerClusterer from "react-google-maps/lib/components/addons/MarkerClusterer";
import {googleMapStyles} from "../../../constants/googleMaps";
import {getUnit, getUnitLatitude, getUnitLongitude} from "../../unit/utils";

/**
 * A component that displays an interactive map of all units
 */
class OverviewMap extends Component {
    constructor() {
        super();
        this.state = {
            mapInitialized: null
        };
    }

    /**
     * Centers the map to fit the bounds of the given
     * {@param units} coordinates using Google Maps API's
     * ref script directly. To be called asynchronously
     * ONLY AFTER the google maps api has been loaded
     */
    setCenterAndZoom = () => {
        if (!this.state.mapInitialized) {
            const bounds = new window.google.maps.LatLngBounds();
            Object.keys(this.props.units).forEach(unitKey => {
                const unit = getUnit(unitKey, this.props.units[unitKey]);
                bounds.extend(new window.google.maps.LatLng(getUnitLatitude(unit), getUnitLongitude(unit)));
            });
            this.refs.map.fitBounds(bounds);
        }
        this.setState(byPropKey('mapInitialized', true));
    };

    componentWillUnmount() {
        if (this.state.units && this.state.units.length > 0) {
            this.state.units.forEach(unit => dbase.doOffUnitValueChanged(unit.unitID));
        }
    }

    render() {
        return (
            <div>
                {
                    this.props.units &&
                    Object.keys(this.props.units).length > 0 &&
                    <GoogleMap
                        ref="map"
                        defaultZoom={12}
                        defaultCenter={{lat: 0.0, lng: 0.0}}
                        defaultOptions={{styles: googleMapStyles}}
                        onIdle={this.setCenterAndZoom}
                    >
                        <MarkerClusterer
                            averageCenter
                            enableRetinaIcons
                            gridSize={30}
                        >
                            {
                                Object.keys(this.props.units).map(unitKey =>
                                    <UnitMarker key={unitKey} unit={getUnit(unitKey, this.props.units[unitKey])}/>
                                )
                            }
                        </MarkerClusterer>
                    </GoogleMap>
                }
            </div>
        );
    }
}

/**
 * Map Redux {@param state} to component props
 */
const mapStateToProps = (state) => ({
    units: state.unitsState.units
});

export default connect(mapStateToProps)(withScriptjs(withGoogleMap(OverviewMap)));



// WEBPACK FOOTER //
// ./src/components/dashboard/overviewmap/OverviewMap.jsx